import { CommentModel } from '../../../shared/data/models/comment.model';
import { PageInfoModel } from '../../../shared/data/models/page-info.model';
import { ReplyCommentState } from './reply-comment.state';

export interface CommentState {
  comment: CommentModel;

  showCommentReply: boolean;
  replyPageInfo: PageInfoModel;
  replyMessages: ReplyCommentState[];
  replyLoading: boolean;
  replyError: string;

  voteCommentLoading: boolean;
  voteCommentError: string;
}

export const initialCommentState: CommentState = {
  comment: null,

  showCommentReply: false,
  replyPageInfo: null,
  replyMessages: [],
  replyError: '',
  replyLoading: false,

  voteCommentLoading: false,
  voteCommentError: ''
};
